import { Component } from '@angular/core';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { ToolPanelComponent } from './components/tool-panel/tool-panel.component';
import { CanvasEditorComponent } from './components/canvas-editor/canvas-editor.component';
import { RightPanelComponent } from './components/right-panel/right-panel.component';

@Component({
    selector: 'app-root',
    imports: [
        ToolbarComponent,
        ToolPanelComponent,
        CanvasEditorComponent,
        RightPanelComponent
    ],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
}
